import React from 'react';
import Header from '../Header/Header';
import Registro from '../Registro/Registro';
import Circulos from '../Circulos/Circulos';
import Desplegable from '../Desplegable/Desplegable';
import Main from '../Main/Main';
import Contacto from '../Contacto/Contacto';
import { Switch, Route } from 'react-router-dom';
import './App.scss';

class App extends React.Component {
  render () {
    return (
      <div className="App">

        <Header />
        <main>
          <Switch>
            <Route
              exact path="/" render={() =>
                <div className="home__container">
                  <Main />
                </div>
              }
            />
            <Route path="/registro" component={Registro} />
            <Route path="/circulos" component={Circulos} />
            <Route path="/desplegable" component={Desplegable} />
            <Route path="/contacto" component={Contacto} />
          </Switch>
        </main>
      </div>
    );
  }
}

export default App;
